import { useState } from 'react'
import AlertState from 'src/types/alert/AlertState'
import UseAlertReturn from 'src/types/alert/UseAlertReturn'

const DEFAULT_ALERT_STATE: AlertState = Object.freeze({
  open: false,
  severity: 'success',
  message: '',
})

const useAlert = (): UseAlertReturn => {
  const [alert, setAlert] = useState<AlertState>(DEFAULT_ALERT_STATE)

  const openAlert = ({
    severity = DEFAULT_ALERT_STATE.severity,
    message,
  }: {
    severity?: AlertState['severity']
    message: AlertState['message']
  }) => {
    setAlert({
      open: true,
      severity,
      message,
    })
  }

  const closeAlert = () => {
    setAlert((prev) => ({ ...prev, open: false }))
  }

  return { alert, open: openAlert, close: closeAlert }
}

export default useAlert
